
export const SliderData = [
  { 
    image:
    'https://cdn.discordapp.com/attachments/922847003141091379/938174643964117063/shoes.png',
    netlify:`https://amazing-shoes-fi.netlify.app/`,
    github:`https://github.com/fidashn/landing-page`
  },
  {
    image:
    'https://cdn.discordapp.com/attachments/922847003141091379/938174604659277895/hotel.png',
    netlify:`https://btm-hotel.netlify.app/`,
    github:`https://github.com/fidashn/HOTEL_WEBSITE`
  },
  {
    image:
    'https://cdn.discordapp.com/attachments/922466869389193236/938213181665452092/bank.png',
    netlify:`https://vir-bank-fi.netlify.app/`,
    github:`https://github.com/fidashn/virtual-bank`
  },
  {
    image:
    'https://cdn.discordapp.com/attachments/922847003141091379/938174670631489536/to-do-list.png',
    netlify:`https://app.netlify.com/sites/todosli/overview`,
    github:`https://github.com/fidashn/to-do-list`
  },
  {
   
    image:'https://cdn.discordapp.com/attachments/922847003141091379/938174566474342440/dice.png',
    netlify:`https://dice-game-f.netlify.app/`,
    github:`https://github.com/fidashn/dice-game1`
  }];